export enum TradePhaseEnum {
  Undefined = "Undefined",
  SellChoice = "SellChoice",
  Created = "Created",
  ContractInformation = "ContractInformation",
  BankInfo = "BankInfo",
  DocumentValidation = "DocumentValidation",
  DocumentApproval = "DocumentApproval",
  LegalCertificates = "LegalCertificates",
  ContractSignatureAcceptenceTerm = "ContractSignatureAcceptenceTerm",
  Analysis = "Analysis",
  SpecialProjectValid = "SpecialProjectValid",
  SpecialProjectApproved = "SpecialProjectApproved",
  Diligence = "Diligence",
  LawyerCompliance = "LawyerCompliance",
  PreSpecialSituation = 'PreSpecialSituation',
  SpecialSituation = "SpecialSituation",
  ContractSignatureCessionTerm = "ContractSignatureCessionTerm",
  PreCartorio = "PreCartorio",
  DigitalCertificate = 'DigitalCertificate',
  Cartorio = "Cartorio",
  Funding = "Funding",
  PreDisbursement = "PreDisbursement",
  Payment = "Payment",
  ContractSignature = "ContractSignature"
}

export const getPreviousPhaseTrade = (phase: TradePhaseEnum) => {
  const keys = Object.keys(TradePhaseEnum);
  return keys.filter(e => keys.indexOf(e) <= keys.indexOf(phase));
};



// WEBPACK FOOTER //
// ./src/services/interfaces/trade/TradePhaseEnum.ts